<script lang="ts">
    import InfoIcon from "../../public/icons/info_icon.svelte";
    import {
        LightningStrikeType,
        lightningDelayError,
        Widget,
        widgetInfo,
        WidgetType,
    } from "../store";

    // true: full-width, right-aligned line under the primary-condition / lightning row
    export let row: boolean = false;

    let strikeType: LightningStrikeType | undefined = undefined;
    let textFill: string = "--default-color";
    let isError: boolean = false;

    widgetInfo.subscribe((value: Widget) => {
        strikeType = value?.lightningStrikeType;
        textFill = value?.type != WidgetType.DEF ? "--primary-color" : "--default-color";
    });

    lightningDelayError.subscribe((value: boolean) => {
        isError = value;
    });
</script>

{#if strikeType === "CG" && !isError}
<!-- radius-label sizes this block at every breakpoint; children scale from it in em -->
<div
class="radius-label strike-type-info"
class:strike-type-row={row}
style="color: var({textFill});"
>
    <div class="strike-type-caption">Lightning Status</div>
    <div class="strike-type-note">
        <div class="strike-type-icon"><InfoIcon fill="currentColor" /></div>
        Cloud-to-ground only
    </div>
</div>
{/if}

<style>
    .strike-type-info {
        display: flex;
        flex-direction: column;
        align-items: inherit;
        line-height: 1.3;
        margin: 0px;
    }
    .strike-type-row {
        flex-basis: 100%;
        align-items: flex-end;
        white-space: nowrap;
        /* sits just under the lightning timer, which carries a 10px bottom/right margin */
        margin: -6px 10px 10px 0px;
    }
    .strike-type-caption {
        font-size: 0.75em;
    }
    .strike-type-note {
        display: flex;
        align-items: center;
        gap: 0.3em;
        font-size: 0.65em;
        opacity: 0.7;
    }
    .strike-type-icon {
        width: 1em;
        flex-shrink: 0;
    }
</style>
